export const CampaignSummary = (builder) => ({
    CampaignSummary: builder.mutation({
        query: ({ page, limit, startDate, endDate, mode, campaign_name }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/campaign_channelSummary',
                method: 'GET',
                params: { page, limit, startDate, endDate, mode, campaign_name },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});